import { ROUTE_PATH } from '@/utils/constants'

export const useGoto = () => {
  const router = useRouter()

  const gotoHome = () => {
    router.replace({
      path: ROUTE_PATH.HOME,
    })
  }

  const gotoLogin = () => {
    window.location.href = ROUTE_PATH.LOGIN
  }

  const gotoChangePwd = () => {
    router.replace({
      path: ROUTE_PATH.CHANGE_PWD,
    })
  }

  return {
    gotoHome,
    gotoLogin,
    gotoChangePwd,
  }
}
